export default "__VITE_ASSET__B5RM$9wq__"